<template>
  <div class="modal drivers-new">
    <div class="modal__wrapper">
      <div class="modal__close" @click="$emit('close-modal')">
        <fa-icon icon="times"></fa-icon>
      </div>
      <div class="modal__title">Nieuwe chauffeur</div>
      <div class="modal__body">
        <div class="form">
          <div>
            <div class="form__field">
              <label>Naam</label>
              <input type="text" class="input" v-model="newItem.NAAM">
            </div>
            <div class="form__field">
              <label>E-mail</label>
              <input type="email" class="input" v-model="newItem.EMAIL">
            </div>
            <div class="form__field">
              <label>GSM</label>
              <input type="tel" class="input" v-model="newItem.GSM">
            </div>
            <div class="form__field">
              <label>Nationaliteit</label>
              <input type="text" class="input" v-model="newItem.NATIONALITEIT">
            </div>
            <div class="form__field">
              <label>Rijksregister nr.</label>
              <input type="text" class="input" v-model="newItem.RIJKSREGISTERNUMMER">
            </div>
            <div class="form__field">
              <label>Geboortedatum</label>
              <DatePicker v-model="newItem.GEBOORTEDATUM" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
          </div>
          <div>
            <div class="form__field">
              <label>Medische keuring</label>
              <DatePicker v-model="newItem.VERVALDAGMEDISCHEKEURING" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
            <div class="form__field">
              <label>Indiensttreding</label>
              <DatePicker v-model="newItem.DATUMINDIENST" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
            <div class="form__field">
              <label>Uitdiensttreding</label>
              <DatePicker v-model="newItem.DATUMUITDIENST" type="date" format="DD/MM/YYYY"
                          value-type="DD/MM/YYYY"></DatePicker>
            </div>
          </div>
          </div>
        <div class="modal__subtitle">Uploads</div>
          <div class="upload-assets">
            <div class="form__field">
              <label>Foto</label>
              <input type="file" accept="image/*" id="FOTO" name="FOTO" class="file-input" @change="imgChanged">
              <div class="file-preview file-preview--image" v-if="imgSource" @click="$emit('preview-click',imgSource)">
                <img :src="imgSource" alt="foto chauffeur">
              </div>
            </div>
          </div>
        </div>
      <div class="modal__controls">
        <button class="button button--cancel" @click="$emit('close-modal')">Annuleer</button>
        <button class="button button--accept" @click="saveClicked">Opslaan</button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import SubcontractorService from "@/services/subcontractor";
import {ObjectMixin} from "@/mixins/ObjectMixin";

export default {

  name: "DriversNew",

  components: {
    DatePicker
  },

  data(){
    return {
      imgSource:"",
      newItem:{
        PERS_ID:this.$store.state.auth.user.PERS_ID,
        NAAM:"",
        EMAIL:"",
        GSM:"",
        NATIONALITEIT:"",
        RIJKSREGISTERNUMMER:"",
        GEBOORTEDATUM:"",
        VERVALDAGMEDISCHEKEURING:"",
        DATUMINDIENST:"",
        DATUMUITDIENST:"",
        FOTO:""
      }
    }
  },

  methods:{
    imgChanged(input){
      if(input.target.files && input.target.files[0]){
        this.newItem.FOTO = input.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imgSource = e.target.result;
        }

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    saveClicked(){
      const data = {...this.newItem};
      if(data.VERVALDAGMEDISCHEKEURING){
        data.VERVALDAGMEDISCHEKEURING = ObjectMixin.formatDateSql(data.VERVALDAGMEDISCHEKEURING);
      }
      if(data.GEBOORTEDATUM){
        data.GEBOORTEDATUM = ObjectMixin.formatDateSql(data.GEBOORTEDATUM);
      }
      if(data.DATUMINDIENST){
        data.DATUMINDIENST = ObjectMixin.formatDateSql(data.DATUMINDIENST);
      }
      if(data.DATUMUITDIENST){
        data.DATUMUITDIENST = ObjectMixin.formatDateSql(data.DATUMUITDIENST);
      }
      SubcontractorService.addDriver(data).then(res => {
        if(res){
          this.$emit('data-edit');
        }
      });
    }
  }

}
</script>
